import { cva, type VariantProps } from "class-variance-authority";

export const textVariants = cva("text-pretty break-words", {
  variants: {
    variant: {
      title: "text-xl leading-7 font-semibold text-foreground",
      cardTitle: "text-lg leading-7 font-semibold text-foreground",
      body: "text-[13px] leading-5 font-medium text-foreground",
      subHeading: "text-[13px] leading-5 font-normal text-muted-foreground",
      caption: "text-xs leading-4 font-normal text-caption-foreground",
    },
    color: {
      foreground: "text-foreground",
      muted: "text-muted-foreground",
      captionForeground: "text-caption-foreground",
      primary: "text-primary",
      secondary: "text-secondary",
      destructive: "text-destructive",
      white: "text-white",
    },
  },
  defaultVariants: {
    variant: "subHeading",
  },
});

export type TextVariantProps = VariantProps<typeof textVariants>;
